import prepareMessageForSmimeDraft from '../actions/prepareMessageForSmimeDraft';
import { mutator } from 'satcheljs';

/**
 * This mutator merges the decoded S/MIME message properties to
 * the draft message that we got from server.
 */
export default mutator(prepareMessageForSmimeDraft, actionMessage => {
    const { smimeMessage, draftMessage } = actionMessage;

    draftMessage.Body = smimeMessage.NormalizedBody;
    // Remove From and Sender properties, because in S/MIME user can only send mails from his/her primary mail account.
    draftMessage.Sender = null;
    draftMessage.From = null;
    draftMessage.IsFromMe = true;
});
